<template>
  <div class="sidebar-help">
    <p class="sidebar-help-text">{{ info.text  }} <a :href="info.link"
         target="_blank"
         class="sidebar-help-text-link">{{$t('message.sidebar.message.clickHere')}}</a></p>
  </div>
</template>

<script>
export default {
  components: {},

  computed: {},

  props: {
    info: {
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.sidebar-help {
  margin: 35px;
  display: flex;
  font-size: 12px;
  color: $grey-4;

  .sidebar-help-text-link {
    color: $green-dark;
    border-bottom: 1px solid $green-dark;
  }
}
</style>
